/** The policyholder's claims list. Every FNOL screen returns here: the policyholder has no claim
 *  detail page, and `/customer/claims/:claimId` is the legacy Complete Filing route, which opens
 *  the "File a Claim" modal over the list. */
export const FNOL_CLAIMS_LIST_PATH = '/customer/claims';

/** Route pattern for filing a new claim. customer.routes.tsx registers this pattern directly, so
 *  the route and every link to it agree on the same literal. */
export const FNOL_NEW_CLAIM_ROUTE_PATH = '/customer/claims/new';

/** Route pattern for the add-details screen. customer.routes.tsx registers this ahead of the
 *  existing `/customer/claims/:claimId` route, which would otherwise swallow it. */
export const FNOL_CLAIM_DETAILS_ROUTE_PATH =
  '/customer/claims/:claimId/details';

/** Where filing a new claim links to. `policyId` pre-selects one of the policyholder's eligible
 *  policies -- FileNewClaim reads it back off the query string on mount. */
export const fnolNewClaimPath = (policyId?: string): string =>
  policyId
    ? `${FNOL_NEW_CLAIM_ROUTE_PATH}?policyId=${encodeURIComponent(policyId)}`
    : FNOL_NEW_CLAIM_ROUTE_PATH;

/** The add-details screen for one claim. One helper so every FNOL screen that links there builds
 *  the same path, rather than each writing its own template string. */
export const fnolClaimDetailsPath = (claimId: string): string =>
  FNOL_CLAIM_DETAILS_ROUTE_PATH.replace(':claimId', claimId);
